import db_lib from '@iscr/xAppLib/libs/db_lib';
import { omit } from '@iscr/helpers/json_functions';

// Org whose conf.doc_dir (state -> doctor id) holds the state default approving doctors - used e.g. for supplier
// purchase orders when the supplier has no approving doctor of its own (see backend pdfs/supplier_order_v1.js)
export const DOC_DIR_ORG_ID = '-LQ9ViFhGTsEgP7y6MID';

const _FRDB_LOC = 'org_cat';
const _DET_FIELDS = [
						// {
						// 	name: "type",
						// 	label:'Type', 
						// 	type: "radio",
						// 	options: [{c:'g', n:'Group'}, {c:'i', n:'Organisation'}],
						// 	placeholder: "Type?",
						// 	param_name: "type",
						// 	req_label: "*",
						// },

						{
							name: "oid",
							label:'oid', 
							type: "text",
							// placeholder: "oid",
							param_name: "oid",
							// req_label: "*",
							read_only: true,

							// view_link_to: true,
						},

						{
							name: "onum",
							label:'onum', 
							type: "number",
							// placeholder: "oid",
							param_name: "onum",
							// req_label: "*",
							read_only: true,

							// view_link_to: true,
						},

						{
							name: "name",
							label:'Name', 
							type: "text",
							placeholder: "Name",
							param_name: "name",
							req_label: "*",

							view_link_to: true,
						},

						// {
						// 	name: "code",
						// 	label:'Unique code', 
						// 	type: "text",
						// 	placeholder: "Code",
						// 	pattern: "a-zA-Z0-9_-",
						// 	param_name: "c",
						// 	req_label: "*",
						// },

						{
							name: "desc",
							label:'Description', 
							type: "textarea",
							placeholder: "Description",
							param_name: "desc",
							req_label: "*",
							valid_not_required: true,
						},

					];

const _MODEL_NAME = 'orgs_model';

const _USE_DATA = 'API'
const _API_NAME = 'orgsAdmin'

const _IT_ID = 'oid'
const _IT_KEY = 'onum'
const _PAR_KEY = 'par_onum'
const _IT_ICO = 'building outline'
const _IT_LABEL = 'name'

// ---- --------------------------------------------  --------------------------------------------  
// ---- --------------------------------------------  --------------------------------------------  

export default class orgs_model extends db_lib {

	static get IT_ID() { return _IT_ID; }
	static get IT_KEY() { return _IT_KEY; }
	static get PAR_KEY() { return _PAR_KEY; }
	static get IT_ICO() { return _IT_ICO; }
	static get IT_LABEL() { return _IT_LABEL; }

	static get FRDB_LOC() { return _FRDB_LOC; }
	static get DET_FIELDS() { return _DET_FIELDS; }
	static get MODEL_NAME() { return _MODEL_NAME; }
	static get USE_DATA() { return _USE_DATA; }
	static get API_NAME() { return _API_NAME; }

	// ----	--------------------------------------------	--------------------------------------------
	// ----	--------------------------------------------	--------------------------------------------

	static async get_orgs_tree (refresh = false, p) {

		// console.log('tree data cache check', !!refresh, !(app.app_data.ws_data), !(app.app_data.ws_data&&app.app_data.ws_data.orgs), !(app.app_data.ws_data&&app.app_data.ws_data.orgs&&app.app_data.ws_data.orgs.tree));

		const want_cont = !!p?.cont;

		// 'tree_cont' returns the same rows as 'tree' plus address/contact/email/phone/conf, and both variants share
		// this one cache slot. Track which one is cached: a cached 'cont' tree satisfies a plain caller, but a plain
		// tree can't satisfy a 'cont' caller - without this, whoever asks first decides whether the extra fields
		// exist, so callers that need an address would intermittently get rows without one.
		const have_cont = !!app.app_data.ws_data?.orgs?.tree_cont;

		if (refresh || !app.app_data.ws_data?.orgs?.tree || (want_cont && !have_cont)) {

			const res = await orgs_model.get_record(null, null, {act:want_cont&&'tree_cont'||'tree'});

			if (!app.app_data.ws_data)				app.app_data.ws_data = {orgs: res};
			else if (!app.app_data.ws_data.orgs)	app.app_data.ws_data.orgs = res;
			else app.app_data.ws_data.orgs.tree = res.tree;

			app.app_data.ws_data.orgs.tree_cont = want_cont;

			// console.log('tree data cached');
		} else {
			// console.log('tree data from cache');
		}

		return app.app_data.ws_data.orgs.tree;

	}

	// ----	--------------------------------------------	--------------------------------------------
	// ----	--------------------------------------------	--------------------------------------------

	static async get_org (onum) {

		return await orgs_model.get_record(null, null, {act:'get', onum:onum});


		// if (!(app.app_data.ws_data&&app.app_data.ws_data.orgs&&app.app_data.ws_data.orgs.by_onum&&app.app_data.ws_data.orgs.by_onum[onum])) {

		// 	const res = await orgs_model.get_record(null, null, {act:'get', onum:onum});

		// 	if (!app.app_data.ws_data)					app.app_data.ws_data = {orgs: {by_onum: {[onum]: res}}};
		// 	else if (!app.app_data.ws_data.orgs)		app.app_data.ws_data.orgs = {by_onum: {[onum]: res}};
		// 	else if (!app.app_data.ws_data.orgs.by_onum)	app.app_data.ws_data.orgs.by_onum = {[onum]: res};
		// 	else app.app_data.ws_data.orgs.by_onum[onum] = res;

		// 	console.log('org data cached');
		// } else {
		// 	console.log('org data from cache');
		// }

		// return app.app_data.ws_data.orgs.by_onum[onum];

	}

	// ----	--------------------------------------------	--------------------------------------------
	// ----	--------------------------------------------	--------------------------------------------

	static get_oid_to_name (oid) {

		const o = app.app_data.ws_data?.orgs?.tree?.filter( o => o.oid == oid )

		return o&&o[0]&&o[0].name || oid;

	}
	
	// ----	--------------------------------------------	--------------------------------------------
	// ----	--------------------------------------------	--------------------------------------------


	static async get_org_by_oid (oid) {

		return await orgs_model.get_record(null, null, {act:'get', oid});

	}

	// ----	--------------------------------------------	--------------------------------------------
	// ----	--------------------------------------------	--------------------------------------------

	static async get_public_org_by_oid (oid) {
		return await orgs_model.get_record(null, null, { act: 'get_public_org', oid });
	}

	// ----	--------------------------------------------	--------------------------------------------
	// ----	--------------------------------------------	--------------------------------------------
	static async get_child_orgs_by_oid (oid) {
		return await orgs_model.get_record(null, null, { act: 'get_child_orgs', oid });
	}

	// ----	--------------------------------------------	--------------------------------------------
	// ----	--------------------------------------------	--------------------------------------------

	// conf.doc is the org's approving doctor (e.g. stamped onto supplier purchase orders). Like other conf
	// items it may be stored as an array, in which case the last entry is the effective one (see the
	// backend org_model.org_conf_itm).
	static approving_doc_id (conf) {
		const doc = conf?.doc;
		return Array.isArray(doc) ? doc[doc.length-1] : doc;
	}

	// ----	--------------------------------------------	--------------------------------------------

	// Where doc_id is used as an approving doctor, looking only at each org's own conf (not inherited):
	//  - orgs:           orgs with doc_id as their approving doctor (conf.doc)
	//  - state_defaults: orgs with doc_id as a state default approving doctor (conf.doc_dir, a state -> doctor
	//                    id map, edited under "Approving Doctors by State" in the org admin), with the states
	//  - state_directory: the state default approving doctors in use (DOC_DIR_ORG_ID's conf.doc_dir), which is
	//                    what purchase orders fall back to once an org's approving doctor is removed
	// Goes straight to the API rather than through get_orgs_tree so it's always fresh and doesn't disturb the
	// cached tree.
	static async get_approving_doc_usage (doc_id) {
		if (!doc_id) return { orgs: [], state_defaults: [], state_directory: {} };

		const res = await orgs_model.get_record(null, null, {act:'tree_cont'});

		if (!Array.isArray(res?.tree))
			throw new Error(res?.err || 'Could not load organisations');

		const orgs = res.tree.filter( o => orgs_model.approving_doc_id(o.conf) === doc_id );

		const state_defaults = res.tree
			.map( o => ({
				...o,
				states: Object.entries(o.conf?.doc_dir || {}).filter( ([, d]) => d === doc_id ).map( ([state]) => state ),
			}) )
			.filter( o => o.states.length );

		const state_directory = res.tree.find( o => o.oid === DOC_DIR_ORG_ID )?.conf?.doc_dir || {};

		return { orgs, state_defaults, state_directory };
	}

	// ----	--------------------------------------------	--------------------------------------------

	// Re-reads the org right before writing so the conf we send back (upd replaces conf wholesale) is current.
	static async remove_approving_doc (onum) {
		const org = await orgs_model.get_org(onum);

		if (!org?.oid)
			throw new Error(`Could not load organisation ${onum}`);

		const conf = omit(org.org_conf || {}, ['doc']);
		const res = await orgs_model.get_record(null, null, {act:'upd', oid:org.oid, data:{conf}});

		if (res?.res === 'err')
			throw new Error(`Could not update ${org.name || org.oid}: ${res.err?.message || res.err || 'unknown error'}`);

		return res;
	}
}
